@let blok = block();

<div
    class='app-footer-recruit__inner-container'>
    @for (child of blok.children; track child._uid) {
        <s1-cms-component [blok]="child">
        </s1-cms-component>
    }
</div>
